import React, { useEffect, useContext, useState, useRef } from "react";

//jQuery initialization
import $ from "jquery";

//functions
import {
  _t,
  managePageHrefLink,
  managePageHrefLinkMobile,
  checkPermission
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../../../contexts/User";


const AccountsSidebar = () => {
  const { t } = useTranslation();

  let { authUserInfo } = useContext(UserContext);

  const [searchTerm, setSearchTerm] = useState("");
  const [matchCount, setMatchCount] = useState(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    handleJquery();
    // Record initially active category
    $(".fk-pos-nav > .fk-pos-nav__list").each(function () {
      if ($(this).hasClass("active")) {
        $(this).attr("data-default-active", "true");
      }
    });
  }, []);

  // Real-time search filter effect
  useEffect(() => {
    const term = searchTerm.toLowerCase().trim();

    if (!term) {
      // Restore all categories and sub-items
      $(".fk-pos-nav > .fk-pos-nav__list").show();
      $(".fk-pos-nav__sub-list").show();
      $(".fk-sm-nav__bar > .fk-sm-nav__list").show();
      $(".fk-pos-nav > .fk-pos-nav__list").each(function () {
        if ($(this).attr("data-default-active") === "true") {
          $(this).addClass("active").find(".fk-pos-nav__sub").show();
        } else {
          $(this).removeClass("active").find(".fk-pos-nav__sub").hide();
        }
      });
      setMatchCount(null);
      return;
    }

    let count = 0;

    // Filter large screen categories and sub-items
    $(".fk-pos-nav > .fk-pos-nav__list").each(function () {
      const $category = $(this);
      const catName = $category.children("a").text().toLowerCase();
      const isCatMatch = catName.includes(term);

      let categoryHasMatches = false;

      $category.find(".fk-pos-nav__sub-list").each(function () {
        const $item = $(this);
        const itemText = $item.text().toLowerCase();

        if (isCatMatch || itemText.includes(term)) {
          $item.show();
          categoryHasMatches = true;
          count++;
        } else {
          $item.hide();
        }
      });

      if (categoryHasMatches || isCatMatch) {
        $category.show().addClass("active");
        $category.find(".fk-pos-nav__sub").show();
      } else {
        $category.hide();
      }
    });

    // Filter small screen (mobile) items
    $(".fk-sm-nav__bar > .fk-sm-nav__list").each(function () {
      const $item = $(this);
      const itemText = $item.text().toLowerCase();
      if (itemText.includes(term)) {
        $item.show();
      } else {
        $item.hide();
      }
    });

    setMatchCount(count);
  }, [searchTerm]);

  //jQuery goes here
  const handleJquery = () => {
    var posHasSub = $(".fk-pos-nav__list-has-sub");
    var posSub = $(".fk-pos-nav__sub");
    $(".fk-pos-nav__list-has-sub > a").on("click", function (e) {
      e.preventDefault();
    });
    posHasSub.on("click", function () {
      $(this).find(posSub).slideDown();
      $(this).siblings().find(posSub).slideUp();
      $(this).addClass("active").siblings().removeClass("active");
      $(this).attr("data-default-active", "true").siblings().removeAttr("data-default-active");
    });
  };

  const renderSearchBar = (isMobile = false) => (
    <div className={`accounts-sidebar-search-box ${isMobile ? "mb-3" : "mb-2"}`}>
      <div className="accounts-sidebar-search-wrapper">
        <span className="accounts-sidebar-search-icon">
          <i className="fa fa-search" aria-hidden="true"></i>
        </span>
        <input
          ref={isMobile ? null : searchInputRef}
          type="text"
          className="form-control accounts-sidebar-search-input"
          placeholder={_t(t("Search accounts..."))}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setSearchTerm("");
            }
          }}
        />
        {searchTerm && (
          <button
            type="button"
            className="accounts-sidebar-search-clear"
            onClick={() => {
              setSearchTerm("");
              if (!isMobile && searchInputRef.current) {
                searchInputRef.current.focus();
              }
            }}
            title={_t(t("Clear search"))}
          >
            <i className="fa fa-times-circle" aria-hidden="true"></i>
          </button>
        )}
      </div>
      {searchTerm.trim() && (
        <div className="accounts-sidebar-search-meta d-flex justify-content-between align-items-center mt-1 px-1">
          <span className="badge badge-light accounts-sidebar-badge">
            {matchCount !== null && (
              <>
                {matchCount}{" "}
                {matchCount === 1 ? _t(t("account found")) : _t(t("accounts found"))}
              </>
            )}
          </span>
          <button
            type="button"
            className="btn btn-link p-0 accounts-sidebar-clear-link"
            onClick={() => setSearchTerm("")}
          >
            {_t(t("Clear"))}
          </button>
        </div>
      )}
    </div>
  );

  return (
    <>
      <style>{`
        .accounts-sidebar-search-box {
          position: relative;
          width: 100%;
        }
        .accounts-sidebar-search-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1.5px solid #d1d5db;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
          overflow: hidden;
        }
        .accounts-sidebar-search-wrapper:focus-within {
          border-color: #0a8d6e;
          box-shadow: 0 0 0 3px rgba(10, 141, 110, 0.15);
        }
        .accounts-sidebar-search-icon {
          position: absolute;
          left: 11px;
          color: #0a8d6e;
          font-size: 13px;
          pointer-events: none;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
        }
        .accounts-sidebar-search-input {
          width: 100% !important;
          height: 38px !important;
          border: none !important;
          background: transparent !important;
          padding-left: 33px !important;
          padding-right: 30px !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          box-shadow: none !important;
          outline: none !important;
        }
        .accounts-sidebar-search-input::placeholder {
          color: #94a3b8 !important;
          font-size: 12.5px !important;
        }
        .accounts-sidebar-search-clear {
          position: absolute;
          right: 8px;
          background: transparent;
          border: none;
          color: #94a3b8;
          padding: 4px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          line-height: 1;
          z-index: 2;
          transition: color 0.15s ease;
        }
        .accounts-sidebar-search-clear:hover {
          color: #ef4444;
        }
        .accounts-sidebar-badge {
          background-color: #e6f4ea !important;
          color: #0a8d6e !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          padding: 3px 8px !important;
          border-radius: 12px !important;
        }
        .accounts-sidebar-clear-link {
          font-size: 11px !important;
          color: #64748b !important;
          text-decoration: none !important;
        }
        .accounts-sidebar-clear-link:hover {
          color: #ef4444 !important;
          text-decoration: underline !important;
        }
        .accounts-sidebar-scroll {
          height: calc(100vh - 170px) !important;
          max-height: calc(100vh - 170px) !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          -webkit-overflow-scrolling: touch !important;
          scrollbar-width: thin !important;
          scrollbar-color: rgba(0, 0, 0, 0.25) transparent !important;
        }
        .accounts-sidebar-scroll::-webkit-scrollbar {
          width: 6px !important;
        }
        .accounts-sidebar-scroll::-webkit-scrollbar-track {
          background: transparent !important;
        }
        .accounts-sidebar-scroll::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.2) !important;
          border-radius: 4px !important;
        }
        .accounts-sidebar-scroll::-webkit-scrollbar-thumb:hover {
          background: rgba(0, 0, 0, 0.35) !important;
        }
      `}</style>

      {/* Navigation for Small Screen  */}
      <div className="d-lg-none">
        <div className="row">
          <div className="col-12">
            {renderSearchBar(true)}
            <div className="fk-sm-nav" data-simplebar>
              <ul className="t-list fk-sm-nav__bar flex-row">
                {/* Foods */}

                {managePageHrefLinkMobile(
                  "/dashboard/accounts/gl-setting",
                  _t(t("GL Module Setting"))
                )}

                {managePageHrefLinkMobile(
                  "/dashboard/accounts/level-1",
                  _t(t("Chart of Account L-1"))
                )}

                {managePageHrefLinkMobile(
                  "/dashboard/accounts/level-2",
                  _t(t("Chart of Account L-2"))
                )}
     

                {managePageHrefLinkMobile(
                  "/dashboard/accounts/level-3",
                  _t(t("Chart of Account L-3"))
                )}

               {/* bank transaction */}
              {managePageHrefLinkMobile(
                "/dashboard/account/transaction/bank-payment",
                _t(t("Bank Payment"))
               )
              }

              { managePageHrefLinkMobile(
                  "/dashboard/account/transaction/cash-payment",
                  _t(t("Cash Payment"))
                )
              }

              {managePageHrefLinkMobile(
                  "/dashboard/account/transaction/journal-voucher",
                  _t(t("Journal Voucher"))
                )
              }

              { managePageHrefLinkMobile(
                  "/dashboard/account/transaction/opening-account",
                  _t(t("Opening Account"))
                )
              }        

              {/* Reports */}
              {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLinkMobile(
                    "/dashboard/account/reports/accounts-report",
                    _t(t("Accounts Reports"))
                  )
                : ""} 

              {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLinkMobile(
                    "/dashboard/account/reports/ledger-report",
                    _t(t("Ledger Reports"))
                  )
                : ""} 

              {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLinkMobile(
                    "/dashboard/account/reports/supplier-ledger-report",
                    _t(t("Supplier Ledger Reports"))
                  )
                : ""} 

                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLinkMobile(
                    "/dashboard/account/reports/trial-balance-report",
                    _t(t("Trial Balance Reports"))
                  )
                : ""} 

                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLinkMobile(
                    "/dashboard/account/reports/balance-sheet-report",
                    _t(t("Balance Sheet Reports"))
                  )
                : ""}

                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLinkMobile(
                    "/dashboard/account/reports/profit-loss-report",
                    _t(t("Profit & Loss Reports"))
                  )
                : ""}

                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLinkMobile(
                    "/dashboard/account/reports/cash-flow-report",
                    _t(t("Cash Flow Report"))
                  )
                : ""}             

              </ul>
            </div>
          </div>
        </div>
      </div>
      
      {/* Navigation for Small Screen  End*/}

      {/* Navigation for large Screen  */}
      <div className="d-none d-lg-block">
        {renderSearchBar(false)}

        {searchTerm.trim() && matchCount === 0 && (
          <div className="text-center py-4 px-3 bg-white rounded border my-2 shadow-sm">
            <div className="mb-2">
              <i className="fa fa-search text-muted" style={{ fontSize: "22px" }}></i>
            </div>
            <p className="text-dark font-weight-bold mb-1" style={{ fontSize: "13px" }}>
              {_t(t("No accounts found"))}
            </p>
            <p className="text-muted mb-3" style={{ fontSize: "11.5px" }}>
              {_t(t("No accounts match"))} "{searchTerm}"
            </p>
            <button
              type="button"
              className="btn btn-sm btn-outline-danger px-3 py-1 font-weight-bold"
              style={{ fontSize: "11px", borderRadius: "20px" }}
              onClick={() => setSearchTerm("")}
            >
              <i className="fa fa-times mr-1"></i> {_t(t("Clear Search"))}
            </button>
          </div>
        )}

        <div
          className="fk-scroll--pos-menu accounts-sidebar-scroll"
          style={{ display: searchTerm.trim() && matchCount === 0 ? "none" : undefined }}
        >
          <ul className="t-list fk-pos-nav">
            {/* GL Setup */}
            <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${
                window.location.pathname.includes("/accounts/") ? "active" : ""
              }`}
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("GL Setup "))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">
              {managePageHrefLink(
                    "/dashboard/accounts/gl-setting",
                    _t(t("GL Module Setting"))
                  )
                  } 

                  {managePageHrefLink(
                    "/dashboard/accounts/level-1",
                    _t(t("Chart of Account L-1"))
                  )
                  }

                  {managePageHrefLink(
                    "/dashboard/accounts/level-2",
                    _t(t("Chart of Account L-2"))
                  )
                  }

                  {managePageHrefLink(
                    "/dashboard/accounts/level-3",
                    _t(t("Chart of Account L-3"))
                  )
                  }           
                
              </ul>
            </li>
            {/* Bank Transactions */}
            <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${
                window.location.pathname.includes("/transaction/") ? "active" : ""
              }`}
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Ledger Transaction"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">

              {managePageHrefLink(
                    "/dashboard/account/transaction/bank-payment",
                    _t(t("Bank Payment"))
                  )
                }

                { managePageHrefLink(
                    "/dashboard/account/transaction/cash-payment",
                    _t(t("Cash Payment"))
                  )
                }
                { managePageHrefLink(
                    "/dashboard/account/transaction/bank-receipt",
                    _t(t("Bank Receipt"))
                  )
                }
                { managePageHrefLink(
                    "/dashboard/account/transaction/cash-receipt",
                    _t(t("Cash Receipt"))
                  )
                }

                {managePageHrefLink(
                    "/dashboard/account/transaction/journal-voucher",
                    _t(t("Journal Voucher"))
                  )
                }

                { managePageHrefLink(
                    "/dashboard/account/transaction/opening-account",
                    _t(t("Opening Account"))
                  )
                }                
                
              </ul>
            </li>
            {/* Reports */}
            <li
              className={`fk-pos-nav__list fk-pos-nav__list-has-sub ${
                window.location.pathname.includes("/reports/") ? "active" : ""
              }`}
            >
              <a
                className="w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase rounded-0 text-left"
                rel="noopener noreferrer"
                href="#"
              >
                {_t(t("Reports"))}
              </a>
              <ul className="t-list fk-pos-nav__sub t-bg-white list-group">

              {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLink(
                    "/dashboard/account/reports/accounts-report",
                    _t(t("Accounts Reports"))
                  )
                : ""}   

              {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLink(
                    "/dashboard/account/reports/ledger-report",
                    _t(t("Ledger Reports"))
                  )
                : ""}

                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLink(
                    "/dashboard/account/reports/payment-report",
                    _t(t("Payment Reports"))
                  )
                  : ""}
                {authUserInfo.permissions !== null &&
                  checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLink(
                    "/dashboard/account/reports/receipt-report",
                    _t(t("Receipt Reports"))
                  )
                  : ""}

              {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLink(
                    "/dashboard/account/reports/supplier-ledger-report",
                    _t(t("Supplier Ledger Reports"))
                  )
                : ""}

                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLink(
                    "/dashboard/account/reports/trial-balance-report",
                    _t(t("Trial Balance Reports"))
                  )
                : ""}

                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLink(
                    "/dashboard/account/reports/balance-sheet-report",
                    _t(t("Balance Sheet Reports"))
                  )
                : ""}

                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLink(
                    "/dashboard/account/reports/profit-loss-report",
                    _t(t("Profit & Loss Reports"))
                  )
                : ""}

                {authUserInfo.permissions !== null &&
                checkPermission(authUserInfo.permissions, "Ledger Report")
                  ? managePageHrefLink(
                    "/dashboard/account/reports/cash-flow-report",
                    _t(t("Cash Flow Report"))
                  )
                : ""}                
              </ul>
            </li>
          </ul>
        </div>
      </div>
      
      {/* Navigation for large Screen End */}
    </>
  );
};

export default AccountsSidebar;
